import React from "react";
import { Icon } from "@cadmakers-ui/icons";
import iconStyles from "../../../../Common/Styles/Icons.module.scss";

import "../../../Styles/ToggleImagesButton.scss";
import "../../../Styles/CommentBox.scss";

type Props = {
  imageCount: number;
  toggle: boolean;
  onToggle: () => void;
};

export const ToggleImagesButton: React.FC<Props> = props => (
  <a onClick={props.onToggle} className="disable-double-click-select">
    <Icon appName="GeneralLayout" assetName="GENERAL_L_Image" className={iconStyles.smallIcon} />
    <span className="toggle-images-count">{props.imageCount}</span>
  </a>
);
